const pains = [
  {
    icon: "ri-emotion-sad-line",
    title: "確定申告の時期が毎年憂うつ…",
    desc: "いつも期限ギリギリで大慌て。何から手をつければいいのかすらわからない。",
  },
  {
    icon: "ri-keyboard-box-line",
    title: "レジは打てるけどパソコンは打てない",
    desc: "キャッシュレス決済の管理や帳簿のつけ方、正直さっぱりです。",
  },
  {
    icon: "ri-file-paper-2-line",
    title: "領収書の山が溜まっていく一方",
    desc: "後で整理しようと思いつつ、どんどん増えていく。何年分かわからなくなってきた。",
  },
  {
    icon: "ri-question-line",
    title: "会計アプリを入れたが使い方がわからない",
    desc: "弥生会計やfreeeを入れてみたけど、難しくて結局放置中。",
  },
  {
    icon: "ri-money-cny-box-line",
    title: "経理を誰かに頼みたいが費用が心配",
    desc: "税理士さんに頼むのは高そう…。でも自分でやるのも限界を感じている。",
  },
  {
    icon: "ri-global-line",
    title: "ホームページやSNSを充実させたい",
    desc: "インスタはやってるけど、ホームページはないまま。集客できる環境を整えたい。",
  },
];

export default function PainPoints() {
  return (
    <section className="py-24 bg-[#F0F7FF]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#0EA5E9] text-sm font-semibold tracking-widest mb-4">PAIN POINTS</p>
          <h2 className="text-3xl font-extrabold text-[#1A2332] mb-6">
            こんなお悩み、ありませんか？
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
            美容サロン・治療院・音楽教室など、ひとりで奮闘する経営者のみなさんからよくいただくお声です。<br />
            ひとつでも当てはまったら、Zenwestにご相談ください。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {pains.map((pain, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 border border-[#E2EEF9] hover:border-[#0EA5E9] hover:shadow-md transition-all duration-300 cursor-default group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#EFF8FF] group-hover:bg-[#0EA5E9] rounded-xl mb-5 transition-colors duration-300">
                <i className={`${pain.icon} text-2xl text-[#0EA5E9] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#1A2332] mb-3 leading-snug">
                {pain.title}
              </h3>
              <p className="text-gray-500 text-base leading-relaxed">{pain.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <div className="inline-flex items-center gap-3 bg-[#1A2332] text-white rounded-full px-8 py-4">
            <i className="ri-checkbox-circle-fill text-[#0EA5E9] text-xl"></i>
            <span className="font-semibold text-base">そのお悩み、Zenwestが全部まとめて解決します。</span>
          </div>
        </div>
      </div>
    </section>
  );
}
